<template>
  <div>
    <div class="group-input col-12 column q-mt-sm">
      <label for="rede_energizada">Rede energizada</label>
      <div class="flex row justify-around">
        <q-radio
          keep-color
          size="lg"
          v-model="itemOsContract.rede_energizada"
          :val="1"
          label="Sim"
          color="red-6"
        />
        <q-radio
          keep-color
          size="lg"
          :val="0"
          v-model="itemOsContract.rede_energizada"
          label="Não"
          color="red-6"
        />
      </div>
    </div>
    <div
      class="group-input col-12 row q-mt-sm"
      v-if="itemOsContract.rede_energizada === 1"
    >
      <RequiredLabel
        title="Rede [Cordoalha Energizada]"
        name="rede_cordoalha_energizada"
      />
      <q-input
        class="col-12"
        outlined
        dense
        color="red-9"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        v-model="itemOsContract.rede_cordoalha_energizada"
        bg-color="white"
        lazy-rules
        name="rede_cordoalha_energizada"
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Valor do TAP/NAP"
        name="valor_tap_nap"
      />
      <q-input
        class="col-12"
        outlined
        dense
        color="red-9"
        type="number"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        v-model="itemOsContract.valor_tap_nap"
        bg-color="white"
        lazy-rules
        name="valor_tap_nap"
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <NapForm :itemOsContract="itemOsContract" />
  </div>
</template>

<script>
  import NapForm from "@/components/SpecialCodes/Forms/NapForm.vue";
import RequiredLabel from "@/components/SpecialCodes/RequiredLabel.vue";

  export default {
    name: "ExternalNewtorkProblemForm",
    components: {
      NapForm,
      RequiredLabel,
    },
    props: {
      itemOsContract: Object,
      isCityBrownField: Boolean,
    },

    setup(props, { emit }) {
      return {};
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }

  .group-input {
    label {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
</style>
